import React, { Component } from 'react';
import Layout from '../../components/layout';
import { withTranslation } from '../../lib/translate';
import { connect } from 'react-redux';
import { getPrivacyPolicy } from '../../store/actions';
import Loading from '../../components/spinner';
import './index.css';
import { Title } from '../../components/common';
import { forwardTo, goBack } from '../../lib/utils';

class Privacy extends Component {
  componentDidMount() {
    this.props.dispatch(getPrivacyPolicy());
  }

  backHandler = () => {
    const fromRegisterPage = this.props.location?.state?.fromRegisterPage;
    if (typeof fromRegisterPage === 'string') {
      forwardTo(fromRegisterPage, { saveRegisterData: true });
    } else {
      goBack();
    }
  };

  render() {
    const { __, privacyPolicy } = this.props;
    return (
      <Loading>
        <Layout  backHandler={this.backHandler} hideSecondToolbar={true}  color="transparent"  headerTitle={__('Privacy Policy')}>
          <div className='page-content'>
            <Title className='page-title-centered'>{__('Privacy Policy')}</Title>
            <div dangerouslySetInnerHTML={{ __html: privacyPolicy }}></div>
          </div>
        </Layout>
      </Loading>
    );
  }
}

const stateToProps = (state) => {
  return {
    privacyPolicy: state.common.privacyPolicy || null,
  };
};

export default connect(stateToProps)(withTranslation(Privacy));
